import { createContext, ReactNode, useMemo } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';

// types
import { ConfigContextValue, ConfigStates } from 'types/config';

export type Props = {
  children: ReactNode;
  /**
   * ZERCODE CHANGE [STD-FE]: config fields driven by the Control Plane tenant
   * branding (fontFamily, borderRadius, ...) are passed in here and ALWAYS win
   * over localStorage user prefs — white-label branding is not a user setting.
   * See @zercode/theme brandingToBerryConfig().
   */
  overrides?: Partial<ConfigStates>;
};

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children, overrides }: Props) {
  const { state, setState, setField, resetState } = useLocalStorage<ConfigStates>('zeredu-admin-config', { ...config, ...overrides });

  const memoizedValue = useMemo(
    () => ({
      state: { ...state, ...overrides },
      setState,
      setField,
      resetState
    }),
    [state, overrides, setField, setState, resetState]
  );

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}
